import type { ExcelFileInfo } from "@/api/excel-import.contract";

const MAX_EXCEL_FILE_SIZE_BYTES = 10 * 1024 * 1024;
const EXCEL_FILE_NAME_PATTERN = /\.(xlsx|xls)$/i;

export type ImportStatusFilter = "all" | ExcelFileInfo["approvalStatus"];

export interface ImportCounts {
  total: number;
  pending: number;
  approved: number;
  rejected: number;
}

export const filterExcelImports = (
  files: ExcelFileInfo[],
  language: string,
  status: ImportStatusFilter,
): ExcelFileInfo[] =>
  files.filter(
    (file) =>
      (language === "all" || file.lang === language) &&
      (status === "all" || file.approvalStatus === status),
  );

export const countExcelImports = (files: ExcelFileInfo[]): ImportCounts => ({
  total: files.length,
  pending: files.filter((file) => file.approvalStatus === "PENDING").length,
  approved: files.filter((file) => file.approvalStatus === "APPROVED").length,
  rejected: files.filter((file) => file.approvalStatus === "REJECTED").length,
});

export const isValidExcelWorkbook = (file: File): boolean =>
  EXCEL_FILE_NAME_PATTERN.test(file.name) &&
  file.size > 0 &&
  file.size <= MAX_EXCEL_FILE_SIZE_BYTES;

export const isExcelImportReady = (
  language: string,
  file: File | null,
): boolean =>
  language.trim().length > 0 && file !== null && isValidExcelWorkbook(file);

